module.exports = __webpack_public_path__ + "static/colaps-8cd8298bca735687d9848fa6ee7ecda9.jpg";